import { combineRules } from '../dependencies';

export const iconRule = ({ theme }) => ({
    fontSize: '25px',

    ':focus': {
        outline: 'transparent',
    },
});

export const disabledRule = combineRules(iconRule, ({ theme }) => ({
    cursor: 'not-allowed',
    opacity: 0.6,

    '&:hover': {
        color: theme.colors.grey,
    },
}));

export const favouriteButtonRule = combineRules(iconRule, ({ theme, favourite }) => ({
    '& .anticon-star': {
        color: favourite ? theme.colors.yellow : theme.colors.grey,

        ':hover': {
            color: theme.colors.yellow,
        },
    },
}));

export const tooltipTextRule = () => ({
    textAlign: 'center',
});
